module.exports = __webpack_public_path__ + "static/img/43_banana.31754cb8.jpg";